import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import {
  createFrontendPlugin,
  createRouteRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';

const rootRouteRef = createRouteRef();

const page = PageBlueprint.make({
  params: {
    path: '/governanca/alertas',
    routeRef: rootRouteRef,
    loader: () =>
      import('./GovernanceAlertsPage').then(module => (
        <module.GovernanceAlertsPage />
      )),
  },
});

export const governanceAlertsPlugin = createFrontendPlugin({
  pluginId: 'governance-alerts',
  title: 'Alertas de Governança',
  icon: <NotificationsActiveIcon />,
  routes: { root: rootRouteRef },
  extensions: [page],
});
